import { render, staticRenderFns } from "./ExclusionCard.vue?vue&type=template&id=6852daa1&"
import script from "./ExclusionCard.vue?vue&type=script&lang=js&"
export * from "./ExclusionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports